import axios from "axios";

const API = axios.create({
  baseURL: "https://apim.crownmarts.com",
  withCredentials: true,
});

API.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const requestUrl = error.config?.url || "";
    const isOtpVerification = requestUrl.includes("/login/verify-otp");

    if (error.response && error.response.status === 401 && !isOtpVerification) {
      localStorage.clear();
      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default API;
